export default function loading(): void {
    const loading = document.querySelector( '.js-loading' );
    const sectionLoading = loading?.closest( 'section' );

    if ( !loading || !sectionLoading ) {
        return;
    }

    if ( document.cookie.split( '; ' ).find( row => row.startsWith( 'visited=' ) ) ) {
        sectionLoading.remove();
        return;
    }

    document.cookie = `visited=true; path=/; max-age=${ 60 * 60 * 24 }`;

    animateCounter( loading, 20, 600, 0 );

    setTimeout( () => {
        animateCounter( loading, 80, 2000, 21 );
    }, 500 );

    setTimeout( () => {
        animateCounter( loading, 100, 1000, 81 );
    }, 1200 );

    setTimeout( () => {
        sectionLoading.addEventListener( 'transitionend', () => {
            sectionLoading.remove();
        }, { once: true } );

        sectionLoading.classList.add( 'is-done' );

        setTimeout( () => {
            sectionLoading.remove();
        }, 700 );
    }, 1800 );
}

function animateCounter( element: Element, target: number, duration = 6000, start = 0 ): void {
    const increment = target / ( duration / 16 );

    const timer = setInterval( () => {
        start += increment;

        if ( start >= target ) {
            start = target;
            clearInterval( timer );
        }

        element.textContent = Math.floor( start ).toString();
    }, 5 );
}
